import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
  Modal,
  Card,
  CardContent,
  CardActions,
  Button
} from '@material-ui/core';
import ws from '../../utils/ws';
import useS3PresignedUrl from '../../hooks/useS3PresignedUrl';

const useStyles = makeStyles(theme => ({
  root: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    boxShadow: theme.shadows[20],
    width: 1080,
    maxHeight: '100%',
    overflowY: 'auto',
    maxWidth: '100%'
  },
  actions: {
    justifyContent: 'flex-end'
  },
  content: {
    padding: theme.spacing(2)
  },
  image: {
    width: '100%',
    objectFit: 'contain'
  }
}));

const ImageModal = props => {
  const { open, onClose, imageUri, bucket, objectKey, className, ...rest } = props;
  const classes = useStyles();
  const presignedUrl = useS3PresignedUrl(bucket, objectKey);

  if (!open) return null;

  const src = bucket && objectKey ? presignedUrl : ws.url(imageUri);

  return (
    <Modal onClose={onClose} open={open}>
      <Card {...rest} className={clsx(classes.root, className)}>
        <CardContent className={classes.content}>
          {src && <img className={classes.image} src={src} />}
        </CardContent>
        <CardActions className={classes.actions}>
          <Button onClick={onClose} variant="contained">
            Close
          </Button>
        </CardActions>
      </Card>
    </Modal>
  );
};

ImageModal.defaultProps = {
  open: false
};

export default ImageModal;
